import { createRouter, createWebHistory } from "vue-router";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import System from "./pages/System";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import SystemAlarms from "./pages/SystemAlarms";
import SystemSmsLog from "./pages/SystemSmsLog";
import CompleteProfile from "./pages/CompleteProfile";
import Profile from "./pages/Profile";
import Reports from "./pages/Reports";
import CreateReport from "./pages/CreateReport";
import store from "./store/index";

const routes = [
  { path: "/", name: "/", meta: { middleware: "auth" }, component: Home },
  { path: "/projects", meta: { middleware: "auth" }, component: Projects },
  { path: "/projects/:id", meta: { middleware: "auth" }, component: Project },
  {
    path: "/projects/:projectId/:systemId",
    meta: { middleware: "auth" },
    component: System,
  },
  {
    path: "/projects/:projectId/:systemId/alarms",
    meta: { middleware: "auth" },
    component: SystemAlarms,
  },
  {
    path: "/projects/:projectId/:systemId/smslog",
    meta: { middleware: "auth" },
    component: SystemSmsLog,
  },
  { path: "/profile", meta: { middleware: "auth" }, component: Profile },
  {
    path: "/reports",
    meta: { middleware: "auth", showBackButton: true },
    component: Reports,
  },
  {
    path: "/reports/create",
    meta: { middleware: "auth", showBackButton: true },
    component: CreateReport,
  },
  { path: "/login", component: Login },
  { path: "/reset-password", component: ResetPassword },
  { path: "/reset-password/:token", component: ResetPassword },
  { path: "/complete-profile/:key", component: CompleteProfile },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Cache middleware to avoid dynamic loading
const authMiddleware = require("./middleware/auth").default;

router.beforeEach(async (to, from, next) => {
  // Handle menu closing asynchronously
  const menuElement = document.getElementById("close-menu");
  if (menuElement) {
    requestAnimationFrame(() => {
      menuElement.click();
    });
  }

  // Update back button state
  store.commit("setShowBackButton", !!to.meta.showBackButton);

  // Handle middleware
  if (to.meta.middleware) {
    try {
      await authMiddleware(next, store);
    } catch (error) {
      console.error("Navigation error:", error);
      next(false);
    }
  } else {
    next();
  }
});

// Add afterEach hook to handle cleanup
router.afterEach(() => {
  // Any cleanup needed after navigation
  window.scrollTo(0, 0);
});

export default router;
